import script from "./ChatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessage.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessage.vue?vue&type=style&index=0&id=7e65e59b&scoped=true&lang=css"
import "./ChatMessage.vue?vue&type=style&index=1&id=7e65e59b&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e65e59b"]])

export default __exports__